/**
 * Format a date string consistently using UTC to avoid timezone shifts
 * This ensures dates like "2024-01-15T00:00:00.000Z" always display as Jan 15
 * regardless of the user's timezone
 */
export const formatDateUTC = (dateString, options = {}) => {
  if (!dateString) return null;
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    
    // Use UTC methods to extract date components
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    
    // Create a date object in local timezone with UTC date values
    // This ensures the date displays correctly regardless of timezone
    const localDate = new Date(year, month, day);
    
    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    
    return localDate.toLocaleDateString('en-US', { ...defaultOptions, ...options });
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
};

/**
 * Format a date string to a simple date format (MM/DD/YYYY) using UTC
 */
export const formatDateSimple = (dateString) => {
  return formatDateUTC(dateString, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};
